import type { ProductVisibility } from "@rogue/universal"

type DealType = {
  title : string,
  key : string,
  urlText? : string | undefined,
  img : { src: string, width: number, height: number },
  darkImg : { src: string, width: number, height: number },
  text : string,
  has : boolean,
}

export const HOT_DEALS: DealType = {
  title   : 'Hotdeals',
  key     : 'rogue_promo_enabled',
  img     : { src: '/logos/logo-hotdeal_cw8smo.svg', width: 163, height: 21 },
  darkImg : { src: '/matte_black/hotdeals-RED-WHITE_zawlfn.svg', width: 172, height: 35 },
  text    : 'All deals available while supplies last. Unannounced deals can drop at any time, for any amount. Stay tuned!',
  has     : true,
}

const CLOSEOUT: DealType = {
  title   : 'Closeout & Sale',
  key     : 'rogue_closeout_and_sale',
  img     : { src: '/logos/logo-closeout_y8dxq9.svg', width: 168, height: 21 },
  darkImg : { src: '/matte_black/closeout-WHITE_py4ryi.svg', width: 170, height: 30 },
  text    : 'Not only general closeout / discontinued gear, but also gently used equipment.',
  has     : true,
}

const BONEYARD: DealType =  {
  title   : 'Boneyard',
  key     : 'rogue_boneyard',
  img     : { src: '/logos/logo-boneyard_cpdju5.svg', width: 140, height: 66 },
  darkImg : { src: '/logos/logo-boneyard_cpdju5.svg', width: 140, height: 66 },
  text    : 'Boneyard gives you the opportunity to purchase discounted top-tier 2nds.',
  has     : true,
}

const HUNDO: DealType = {
  title   : 'Hundopricing',
  key     : 'rogue_hundo_enabled',
  img     : { src: '/logos/logo-hundo_jc0ghv.svg', width: 234, height: 21 },
  darkImg : { src: '/matte_black/hundopricing-RED-WHITE_vi4o9u.svg', width: 230, height: 30 },
  text    : 'The more weight you purchase the cheaper the price per pound becomes.',
  has     : true,
}

const FIVE_FOR_FIVE: DealType = {
  title   : '5 for 5',
  key     : 'black_friday_dropship',
  urlText : '5for5',
  img     : { src: '/matte_black/5-for-5-US-Black.svg', width: 139, height: 66 },
  darkImg : { src: '/matte_black/5-for-5-US-White.svg', width: 139, height: 66 },
  text    : 'Add 5 or more qualifying items to your cart and those qualifying items ship for $5',
  has     : true,
}

export const DEAL_TYPES: DealType[] = [HOT_DEALS, CLOSEOUT, BONEYARD, HUNDO]

export const BLACK_FRIDAY_DEAL_TYPES: DealType[] = [FIVE_FOR_FIVE, HOT_DEALS, HUNDO, CLOSEOUT, BONEYARD]

export interface IPublicCategoryProduct {
  name: string;
  attributes: {
    [attributeCode: string]: unknown;
  };
  related?: {
    productId: number;
    childId?: number;
    variationKey?: string;
    thumbnail: string;
    price?: number;
    special_price?: string;
    url?: string;
    sku?: string;
    name?: string;
    attributes?: { [attributeCode: string]: unknown };
    inStock?: boolean;
    imgCount?: number;
  }[];
  inStock: boolean;
  productId: number;
  childId?: number;
  variationKey?: string;
  primaryCategoryId: number;
  url: string;
  sku: string;
  imgCount: number;
  weight?: number;
  groupSku?: string;
  breadcrumbs?: string;
  price?: number;
  special_price?: string;
  thumbnail?: string;
  visibility: ProductVisibility;
  position?: number;
}

export type TDealsIndex = {
  sorts: { [p: string]: number[] };
  products: IPublicCategoryProduct[];
};